/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 210,
    height: 221,
    viewBox: '0 0 210 221',
    data: '<path pid="0" d="M23.33 197.74A23.33 23.33 0 0046.67 221h116.66a23.33 23.33 0 0023.34-23.26V58.158H23.33V197.74zM46.67 81.421h116.66l.02 116.319H46.67V81.421zM140 23.263V0H70v23.263H0v23.263h210V23.263h-70zM70 174.474h23.33v-69.79H70v69.79zm46.67 0H140v-69.79h-23.33v69.79z" fill-rule="evenodd"/>'
  }
})
